<div class="adx-lib-widget-setting-wrapper">
    <div class="adx-settings-dialog">
        <div class="adx-settings-header">
            <h2 class="adx-settings-title">
                {{ "STREAMING.AHOY_VIDEO.WIDGET.VIDEO" | translate }} {{ "STREAMING.AHOY_VIDEO.WIDGET.SETTINGS" | translate }}
            </h2>
            <button mat-icon-button
                    [mat-dialog-close]="true"
                    aria-label="Close Button"
                    class="adx-settings-close-btn">
                <fa-icon [icon]="'xmark'"></fa-icon>
            </button>
        </div>

        <div class="adx-settings-content">
            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ "STREAMING.AHOY_VIDEO.WIDGET.TITLE" | translate }}</mat-label>
                    <input matInput type="text" [(ngModel)]="widgetTitle">
                </mat-form-field>
            </div>

            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ 'STREAMING.AHOY_VIDEO.WIDGET.WIDGET_HEADER_DISPLAY_OPTIONS' | translate }}</mat-label>
                    <mat-select [(value)]="selectedWidgetHeaderOption" (selectionChange)="selectHeaderOption($event)">
                        @for (option of (ahyortcVideoStreamWidget.settings.widgetHeader | keyvalue); track option.key) {
                            <mat-option [value]="option.key" [disabled]="option.key === 'alwaysOff' || option.key === 'transparent'">
                                {{ getText(option.key) | translate }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ "STREAMING.AHOY_VIDEO.WIDGET.STREAMS" | translate }}</mat-label>
                    <mat-select [(value)]="streamUuid" (selectionChange)="onStreamChange($event.value)">
                        @for (camera of (cameras); track camera.uuid) {
                            @for (stream of (camera.streams); track stream.uuid) {
                                <mat-option [value]="stream.uuid">
                                    {{ camera.name }} ({{ stream.codec }} - {{ (stream.bitrate.max / 1000000) | number:'1.0-2' }} Mbps)
                                </mat-option>
                            }
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="adx-settings-footer">
            <button mat-raised-button
                    type="button"
                    [mat-dialog-close]="true">
                {{ "STREAMING.AHOY_VIDEO.WIDGET.CANCEL" | translate }}
            </button>
            <button mat-raised-button
                    class="primary"
                    type="submit"
                    (click)="onSubmit()">
                {{ "STREAMING.AHOY_VIDEO.WIDGET.SAVE" | translate }}
            </button>
        </div>
    </div>
</div>
